import { a as PUBLIC_GLIMMR_API_KEY } from "./public.js";
import { h as SERVER_HOST } from "./private.js";
import { e as error } from "./index2.js";
const isProduction = process.env.NODE_ENV === "production";
process.env.NODE_ENV === "development";
const handleRequest = (handler, secure = true) => {
  return async (event) => {
    const { request } = event;
    const secret = request.headers.get("X-Glimmr-Secret-Key") || event.url.searchParams.get("key");
    event.locals.secret = secret;
    if (secure && !secret) {
      error(403, {
        message: "Unauthorized"
      });
    }
    if (secure && secret) {
      const isUsingSecretKey = secret === PUBLIC_GLIMMR_API_KEY;
      const isClientRequest = secret !== PUBLIC_GLIMMR_API_KEY;
      const isNotFromServer = event.getClientAddress() !== SERVER_HOST;
      const isMaliciousRequest = isUsingSecretKey && isNotFromServer && isProduction;
      if (isMaliciousRequest) {
        error(403, {
          message: "Unauthorized"
        });
      }
      if (isClientRequest) {
        const response = await event.fetch(`/api/users/${secret}`);
        if (!response.ok) {
          error(403, {
            message: "Unauthorized"
          });
        }
        event.locals.user = await response.json();
      }
    }
    return handler(event);
  };
};
export {
  handleRequest as h
};
